module.exports = __webpack_public_path__ + "static/media/calendar-plus.e8757ce4.svg";